import { render } from "./AboutLu.vue?vue&type=template&id=a14ec7f0"
const script = {}

import exportComponent from "/Users/isamu/ss/web3/laidbacklu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__